const defaultDelay = 500;

const useDebounce = (func, delay = defaultDelay) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  };
};

export default useDebounce;
